import { appBaseUrl } from "@/variables"

import { SubscriptionClient } from "@/lib/api"


const initialState = () => ({
    api: new SubscriptionClient(appBaseUrl),
    subscriptions: [],
    invoices:[],
    checkoutInvoice:{ transactionId: "", postDate:"" , paymentId: "", total:"", completedDate:"",id :""},
    externalPaymentUrl:{url:""},
    invoiceInfo:{},
    subscriptionDetail:{},
    subscriptionLookup: {subscriptionItemsLookup: {}},
    unpaidInstallments:[]

});

// State object
const state = {
    api: new SubscriptionClient(appBaseUrl),
    subscriptions: [],
    invoices:[],
    checkoutInvoice:{ transactionId: "", postDate:"" , paymentId: "", total:"", completedDate:"",id :""},
    externalPaymentUrl:{url:""},
    invoiceInfo:{},
    subscriptionDetail:{},
    subscriptionLookup: {subscriptionItemsLookup: {}},
    unpaidInstallments:[]
}
 
// Getter functions
const getters = {
    getApi(state) {
        return state.api;
    },
    subscriptions(state) {
        return state.subscriptions;
    },
    invoices(state) {
        return state.invoices;
    },
    checkoutInvoice(state) {
        return state.checkoutInvoice;
    },
    externalPaymentUrl(state) {
        return state.externalPaymentUrl;
    },
    invoiceInfo(state) {
        return state.invoiceInfo;
    },
    subscriptionDetail(state){
        return state.subscriptionDetail;
    },
    subscriptionLookup(state){
        return state.subscriptionLookup;
    },
    unpaidInstallments(state){
        return state.unpaidInstallments;
    }
}

// Actions 
const actions = {
   
    async createInvoice({state, commit},{subscriptionInstallmentIds}){
        
        
        let model = {
            subscriptionInstallmentIds: subscriptionInstallmentIds
        };

        const response = await state.api.createInvoice(model);

        
        commit('createInvoiceCompleted', response);
    },

    async subscribeToItem({state, commit}, {itemId, amount}){
       
        let model = {
            itemId: itemId,
            amount: amount
        };

        await state.api.subscribeToItem(model);

        commit('subscribeToItemCompleted');
    },

    async loadCheckoutInvoice({state, commit}, invoiceNumber){
        const response = await state.api.invoiceSummaryByNumber(invoiceNumber);

        commit('loadCheckoutInvoiceCompleted', response);
    },
    async loadCheckoutInvoiceByPaymentInfo({state, commit}, {invoiceNumber,paymentId,transactionId}){
        const response = await state.api.invoiceSummaryByPaymentInfo(invoiceNumber, paymentId, transactionId);
        commit('loadCheckoutInvoiceCompleted', response);
    },
    async loadInvoiceInfoByPaymentInfo({state, commit}, {invoiceNumber,paymentId,transactionId}){
        const response = await state.api.invoiceDetailByPaymentInfo(invoiceNumber, paymentId, transactionId);
        commit('loadInvoiceInfoByPaymentInfoCompleted', response);
    },

    async loadCustomerSubscriptions({state, commit}){
        const response = await state.api.customerSubscriptions();

        commit('loadCustomerSubscriptionsCompleted', response);
    },

    async loadSubscriptionDetail({state, commit}, subscriptionId){

        const response = await state.api.subscriptionDetailById(subscriptionId);

        commit('loadSubscriptionDetailCompleted', response);
    },

    async loadSubscriptionLookup({state, commit}){
        const response = await state.api.subscriptionLookup();

        commit('loadSubscriptionLookupCompleted', response);
  
    },

    async updateSubscription({state, commit}, {subscriptionId, status, amount}){
     
        let model = {
            subscriptionId: subscriptionId,
            status: status,
            amount: amount
        };
        await state.api.updateSubscription(model)

        commit('updateSubscriptionCompleted');

    },

    async loadUnpaidInstallments({state, commit}){
        
        const response = await state.api.unpaidInstallments();

        commit('loadUnpaidInstallmentsCompleted', response);

    },

    async addInstallments({state, commit}, {subscriptionId, numberOfInstallments}){

        let model = {
            subscriptionId : subscriptionId,
            numberOfInstallments : numberOfInstallments
        };

        await state.api.addMultipleInstallments(model);

        const response = await state.api.subscriptionDetailById(subscriptionId);

        commit('loadSubscriptionDetailCompleted', response);

    },

    async cancelSubscription({state, commit}, subscriptionId){

        await state.api.cancelSubscription(subscriptionId);

        const response = await state.api.subscriptionDetailById(subscriptionId);

        commit('loadSubscriptionDetailCompleted', response);

    }
   
}

// Mutations
const mutations = {

    createInvoiceCompleted(state, externalPaymentModel){
        state.externalPaymentUrl = externalPaymentModel;
    },

    loadCheckoutInvoiceCompleted(state, invoice){
        state.checkoutInvoice = invoice
    },
    loadInvoiceInfoByPaymentInfoCompleted(state, invoice){
        state.checkoutOrder = invoice;
    },
    loadCustomerSubscriptionsCompleted(state, subscriptions){
        state.subscriptions = subscriptions;
    },
    loadSubscriptionDetailCompleted(state, subscription){
        state.subscriptionDetail = subscription;
    },
    loadSubscriptionLookupCompleted(state, lookup){
        state.subscriptionLookup = lookup;
    },
    updateSubscriptionCompleted(){},
    subscribeToItemCompleted(){},
    loadUnpaidInstallmentsCompleted(state, installments){
        state.unpaidInstallments = installments;
    },
    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
    loadToken(state){
        //console.log('OrderloadToken');
        let token = window.localStorage.getItem('token') || ""
        //console.log(`Order token:${token}`);
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer ${token}`};
    },

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}